module.exports = __webpack_public_path__ + "static/img/colektia_red.e31e5a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colektia_red.png
// module id = kWsS
// module chunks = 11